<app-contentpopup [contentPopups]="contentPopups" [content_value]="content_value" [contentKey]="contentKey"
  [contentTableArray]="contentTableArray" [content_Details]="content_Details" (closecontentpopup)="closecontentpopup()"
  [tablevalues]="tablevalues" [tablekeys]="tablekeys">
</app-contentpopup>
<p *ngIf="ShowLmsMessage != ''" style="color: red; font-weight: bold; text-align: center; text-decoration: underline;">
  {{ ShowLmsMessage }}
</p>
<table class="table table-bordered" id="excel-table">
  <div class="table-responsive">
    <thead *ngIf="!this.paramsValues.section">
      <tr>
        <th *ngIf="showCheckBox" style="text-align: center;">Select</th>
        <th></th>
        <th>
          <i class="fa fa-edit icons" (click)="editbtn()"></i>
          <i class="fa fa-download icons" title="Dowload file" (click)="downloadFiles()"></i>
          <i class="fa fa-check-square icons" title="Download upon selection" (click)="downloadSelected()"></i>
        </th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let Obj of DragData | Object2keyvalue; let index=index"
        [ngStyle]="{'display': (Obj.key === 'colorindicator' || Obj.key === 'field_information') ?'none' : ' ' }">
        <td *ngIf="showCheckBox"><input type="checkbox" style="margin-left: 2.5rem;"
            (click)="selected_checbox(Obj.key, index)" /></td>
        <td #headerids
          [ngStyle]="{'display': (Obj.key === 'colorindicator' || Obj.key === 'field_information') ?'none' : ' ' }"
          [ngClass]="[getcolorcode(Obj.key,DragData.colorindicator)]">
          {{Obj.key}}
          <span class="tooltip-container">
            <i class="fas fa-info-circle info-icon"></i>
            <div class="custom-tooltip" [innerHTML]="getTooltipContent(Obj.key)"></div>
          </span>
          <div class="action-buttons">
            <button pButton [label]="fieldInformation?.[Obj.key]?.[0]?.field_verified === true ? 'Verified' : 'Verify'"
              class="custom-button verify-btn" (click)="verifyField(Obj.key)"
              [disabled]="fieldInformation?.[Obj.key]?.[0]?.field_verified === true"
              [ngStyle]="{ 'cursor': fieldInformation?.[Obj.key]?.[0]?.field_verified === true ? 'not-allowed' : 'pointer' }">
            </button>

            <button pButton
              [label]="fieldInformation?.[Obj.key]?.[0]?.field_reviewed === true ? 'Under Review' : 'Review'"
              class="custom-button review-btn" (click)="openReviewDialog(Obj.key)"
              [disabled]="fieldInformation?.[Obj.key]?.[0]?.field_reviewed === true"
              [ngStyle]="{ 'cursor': fieldInformation?.[Obj.key]?.[0]?.field_reviewed === true ? 'not-allowed' : 'pointer' }">
            </button>
          </div>
        </td>
        <td>
          <div *ngIf="Obj.value | arrayChk;else displayvalue;let is=index">
            <div *ngIf="Obj.value | tableChk;else list">
              <div class="table-responsive">
                <table class="table table-bordered" id="innertable">
                  <thead style="font-size: 12px;">
                    <tr>
                      <ng-container *ngFor="let headers of getSectionHeaders(Obj.key, Obj.value)">
                        <th *ngIf="headers !== 'Evidence' && headers?.toLowerCase() !== 'evidence'"
                          id="innertableheader">
                          <p>{{ headers }}</p>
                          <!-- <p [ngClass]="[showedit?'editcls':'editdisable']" ><input type="text" (change)="editdata($event,Obj.value,Obj.key)" class="p1" value={{headers}}/></p> -->
                        </th>
                      </ng-container>
                    </tr>
                  </thead>
                  <tbody style="font-size: 10px;">
                    <tr *ngFor="let trows of Obj.value; let m=index; trackBy: trackByIndex">
                      <ng-container
                        *ngFor="let rdata of getSectionRowCells(Obj.key, Obj.value, trows); let iindex =index; trackBy: trackByIndex">
                        <td
                          *ngIf="getSectionHeaders(Obj.key, Obj.value)[iindex] !== 'Evidence' && getSectionHeaders(Obj.key, Obj.value)[iindex]?.toLowerCase() !== 'evidence'">
                          <p [ngClass]="[showedit?'editcls':'editdisable']">
                            <ng-container
                              *ngIf="Obj.key === 'Lifecycle Management' && getSectionHeaders(Obj.key, Obj.value)[iindex] === 'Comment'; else standardInput">
                              <ckeditor [editor]="Editor" [ngModel]="rdata"
                                (ngModelChange)="editdata($event,Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key,'rdata',iindex)">
                              </ckeditor>
                            </ng-container>
                            <ng-template #standardInput>
                              <input type="text"
                                (change)="editdata($event,Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key,'rdata',iindex)"
                                [ngClass]="[rdata.length>=20?'input-size':'']" value={{rdata}} id={{rdata}} />
                            </ng-template>
                          </p>
                          <div [ngClass]="[!showedit && Obj.key !=='FDA label'?'editcls':'editdisable']">
                            <ng-container
                              *ngIf="Obj.key === 'Lifecycle Management' && getSectionHeaders(Obj.key, Obj.value)[iindex] === 'Formulations Under Trial' && rdata && rdata !== 'N/A'; else checkIndication">
                              <ul style="margin: 0; padding-left: 20px;">
                                <li *ngFor="let formulation of rdata.split('|')" style="margin-bottom: 5px;">
                                  {{ formulation.trim() }}
                                </li>
                              </ul>
                            </ng-container>
                            <ng-template #checkIndication>
                              <ng-container
                                *ngIf="['Patient Population', 'Lifecycle Management'].includes(Obj.key) && getSectionHeaders(Obj.key, Obj.value)[iindex] === 'Indication'; else checkPatientPopulation">
                                <ul style="margin: 0; padding-left: 20px;">
                                  <li *ngFor="let indication of rdata.split('|')" style="margin-bottom: 5px;">
                                    {{ indication.trim() }}
                                  </li>
                                </ul>
                              </ng-container>
                            </ng-template>
                            <ng-template #checkPatientPopulation>
                              <ng-container
                                *ngIf="getSectionHeaders(Obj.key, Obj.value)[iindex] === 'Patient Population' && rdata && rdata !== 'N/A' && rdata.includes('|'); else checkNCTId">
                                <ul style="margin: 0; padding-left: 20px;">
                                  <li *ngFor="let pop of rdata.split('|')" style="margin-bottom: 5px;">
                                    {{ pop.trim() }}
                                  </li>
                                </ul>
                              </ng-container>
                            </ng-template>
                            <ng-template #checkNCTId>
                              <ng-container
                                *ngIf="getSectionHeaders(Obj.key, Obj.value)[iindex] === 'NCTId' && rdata && rdata !== 'N/A'; else checkLifecycleSource">
                                <a [href]="clinicalTrialsUrl + rdata" target="_blank"
                                  style="color: blue; text-decoration: underline;">
                                  {{rdata}}
                                </a>
                              </ng-container>
                            </ng-template>
                            <ng-template #checkLifecycleSource>
                              <ng-container
                                *ngIf="Obj.key === 'Lifecycle Management' && getSectionHeaders(Obj.key, Obj.value)[iindex] === 'Source'; else normalDisplay">
                                <ng-container *ngIf="getNctId(rdata); else openEvidence">
                                  <a [href]="clinicalTrialsUrl + getNctId(rdata)" target="_blank"
                                    style="text-decoration: underline;">
                                    {{rdata}}
                                  </a>
                                </ng-container>
                                <ng-template #openEvidence>
                                  <ng-container *ngIf="Obj.value[m]?.Evidence; else plainTextSource">
                                    <a href="javascript:void(0)"
                                      (click)="openEvidencePopup(Obj.value[m]?.Evidence, Obj.value[m])"
                                      style="text-decoration: underline; cursor: pointer;">
                                      {{rdata}}
                                    </a>
                                  </ng-container>
                                  <ng-template #plainTextSource>
                                    <p style="margin: 0;">{{rdata}}</p>
                                  </ng-template>
                                </ng-template>
                              </ng-container>
                            </ng-template>
                            <ng-template #normalDisplay>
                              <ng-container
                                *ngIf="Obj.key === 'Lifecycle Management' && getSectionHeaders(Obj.key, Obj.value)[iindex] === 'Comment'; else standardDisplay">
                                <div [innerHTML]="sanitizeHtml(rdata)"></div>
                              </ng-container>
                              <ng-template #standardDisplay>
                                <p style="margin: 0;">
                                  {{Obj.key === 'Dosage and Administration' || Obj.key === 'Recommended dose' ? '' :
                                  getSafeDisplayValue(rdata)}}
                                </p>
                              </ng-template>
                            </ng-template>
                          </div>
                        </td>
                      </ng-container>
                      <i *ngIf="Obj.value.length > 1 && showedit" [ngClass]="['editcls']"
                        style="font-size: 20px; cursor: pointer; margin: 10px;" class="fas fa-trash float-left"
                        (click)="deleteRow(Obj.value, m)">
                      </i>
                    </tr>

                    <i [ngClass]="[showedit?'editcls':'editdisable']" style="font-size: 20px;margin-top: 10px;"
                      class="fas fa-plus float-left"
                      (click)="addItems(Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key)"></i>
                    <button [ngClass]="[showedit?'editcls':'editdisable']" style="font-size: 15px;
                      margin-left: 35px;
                      margin-top: 10px;" (click)="deleteTable(Obj.key)">
                      Delete Table
                    </button>
                    <!-- <button [ngClass]="[!showedit && Obj.key !=='FDA label'?'editcls':'editdisable']"
                        *ngIf="Obj.value.length>sliceEnd" class="btn btn-success"
                        (click)="showLess(Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key)">Show More</button> -->

                  </tbody>
                </table>
              </div>
            </div>
            <ng-template #list>
              <ul>

                <li *ngFor="let lItems of Obj.value;let inds=index">
                  <p [ngClass]="[showedit?'editcls':'editdisable']">
                    <!-- <input type="text" [ngClass]="[lItems.length>=20?'input-size':'']" (change)="editdata($event,Obj.value,Obj.key,lItems,inds,'lItems')" value={{lItems}} /> -->
                    <textarea [ngClass]="[lItems.length>=20?'input-size':'']"
                      (change)="editdata($event,Obj.value,Obj.key,lItems,inds,'lItems')" style="height: 30px;"
                      value={{lItems}} cols="30" rows="10"></textarea>
                    <i *ngIf="Obj.value.length > 1 && inds > 0" class="fas fa-trash"
                      style="font-size: 20px; cursor: pointer; margin-left: 10px;"
                      (click)="deleteListItem(Obj.value, Obj.key, inds)"></i>
                  </p>
                  <p [ngClass]="[!showedit?'editcls':'editdisable']">

                    {{lItems}}

                  </p>

                </li>
                <i [ngClass]="[showedit?'editcls':'editdisable']" style="font-size: 20px;"
                  class="fas fa-plus float-left" (click)="addListItem(Obj.value,lItems,Obj,m,Obj.key)"></i>
                <button [ngClass]="[showedit?'editcls':'editdisable']" style="margin-left: 35px;"
                  (click)="addTable(Obj.value,lItems,Obj,m,Obj.key)">Add Table</button>
                <!-- <button [ngClass]="[!showedit && Obj.key !=='FDA label'?'editcls':'editdisable']"
                    *ngIf="Obj.key !== 'Dosage and Administration' && Obj.key !== 'Recommended dose' &&  Obj.key !== 'Indications and Usage' && Obj.value.length>5"
                    class="btn btn-success"
                    (click)="showArray(Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key)">Show
                    More</button> -->

              </ul>
            </ng-template>
          </div>
          <ng-template #displayvalue>
            <ng-container *ngIf="['Additional Comments on Clinical Info'].includes(Obj.key)">
              <div [ngClass]="[showedit ? 'editcls' : 'editdisable']">
                <ckeditor [editor]="Editor" [ngModel]="Obj.value"
                  (ngModelChange)="editdata($event, Obj.value, Obj.key, index, '')">
                </ckeditor>
              </div>
              <div class="editor-content" style="margin-bottom: 10px;">
                <p [ngClass]="[showedit ? 'editdisable' : 'editcls']" [innerHTML]="sanitizeHtml(Obj.value)">
                </p>
              </div>
            </ng-container>

            <ng-container *ngIf="!['Additional Comments on Clinical Info'].includes(Obj.key)">
              <p
                [ngClass]="[showedit && Obj.key !== 'FDA label' && Obj.key !== 'FDA product specific BE guidance' ? 'editcls' : 'editdisable']">
                <input type="text" [ngClass]="[Obj.value?.length >= 20 ? 'input-size' : '']" value="{{Obj.value}}"
                  (change)="editdata($event, Obj.value, Obj.key, index, '')" />
              </p>
              <p
                [ngClass]="[!showedit && Obj.key !== 'FDA label' && Obj.key !== 'FDA product specific BE guidance' ? 'editcls' : 'editdisable']">
                {{ Obj.value }}
              </p>
            </ng-container>

            <!-- <p
              [ngClass]="[showedit && Obj.key !=='FDA label' && Obj.key !== 'FDA product specific BE guidance'?'editcls':'editdisable']">
              <input type="text" [ngClass]="[Obj.value?.length>=20?'input-size':'']" value={{Obj.value}}
                (change)="editdata($event,Obj.value,Obj.key,index,'')" />
            </p>
            <p
              [ngClass]="[!showedit && Obj.key !=='FDA label' && Obj.key !== 'FDA product specific BE guidance'?'editcls':'editdisable']">
              {{Obj.value}}

            </p> -->
            <i [ngClass]="[showedit?'editcls':'editdisable']" style="font-size: 20px;" class="fas fa-plus float-left"
              (click)="addListItem(Obj.value, Obj.key, Obj, Obj, Obj.key)"></i>
            <button [ngClass]="[showedit?'editcls':'editdisable']" style="margin-left: 35px;"
              (click)="addTable(Obj.value,lItems,Obj,m,Obj.key)">Add Table</button>

            <i [ngClass]="[ Obj.key ==='FDA label' && Obj.value !== 'N/A'?'editcls':'editdisable']"
              (click)="openPdf(Obj.value)" class="fa fa-file-pdf-o" style="font-size: 30px;"></i>
            <i [ngClass]="[ Obj.key ==='FDA product specific BE guidance' && Obj.value !== 'N/A'?'editcls':'editdisable']"
              (click)="openPdf(Obj.value)" class="fa fa-file-pdf-o" style="font-size: 30px;"></i>
            <div *ngIf="Obj.key ==='FDA label' && Obj.value === 'N/A'">N/A</div>
            <div *ngIf="Obj.key ==='FDA product specific BE guidance' && Obj.value === 'N/A'">N/A</div>
          </ng-template>

          <div *ngFor="let edited of isChanged(Obj.key)">
            <div *ngIf="edited === Obj.key" [id]="Obj.key">
              <i class="fa fa-check" title="Accept" (click)="handelAction(Obj,'accept')"
                style="cursor: pointer;color:#2bc44e;padding-left:1rem;"></i>
              <i class="fa fa-remove" title="Reject" (click)="handelAction(Obj,'reject')"
                style="cursor: pointer;padding-left:3rem;color:red"></i>
            </div>
          </div>

        </td>

      </tr>
      <tr>
        <td *ngIf="showCheckBox">
          <button class="btn btn-primary" (click)="downloadSelectedData()">Download</button>
        </td>
      </tr>
    </tbody>
  </div>
</table>
<p-dialog header="Review Entry" [(visible)]="displayReviewDialog" [modal]="true" [closable]="false"
  class="custom-dialog">
  <div class="dialog-content">
    <div class="p-field">
      <label for="email">Select Email:</label>
      <p-dropdown [options]="emailList" [(ngModel)]="selectedEmail" placeholder="Select Email">
      </p-dropdown>
      <div *ngIf="submitted && !selectedEmail" class="error-text">
        Email is required.
      </div>
    </div>

    <div class="p-field">
      <label for="key">Key Name:</label>
      <input id="key" type="text" pInputText [(ngModel)]="selectedKey" readonly class="readonly-input">
    </div>

    <div class="p-field">
      <label for="comment">Comment:</label>
      <textarea id="comment" pInputTextarea [(ngModel)]="reviewComment" rows="2" cols="40"
        class="comment-box"></textarea>
      <small class="comment-warning">
        {{ reviewComment.length < 15 ? 'Minimum 15 characters required.' : '&nbsp;' }} </small>
    </div>
  </div>

  <p-footer>
    <button type="button" pButton icon="pi pi-times" label="Cancel" class="cancel-btn"
      (click)="displayReviewDialog = false"></button>
    <button type="button" pButton icon="pi pi-check" label="Submit" class="submit-btn" [disabled]="!isCommentValid()"
      (click)="submitReview()"></button>
  </p-footer>
</p-dialog>
<div *ngIf="showedit" class="text-center">
  <button class="btn btn-primary" (click)="saveEdit()">Save</button>
</div>

<p-dialog header="Evidence" [(visible)]="displayEvidencePopup" [modal]="true"
  [style]="{width: '50vw', minWidth: '400px'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
  <div *ngIf="evidencePopupData" style="padding-top: 10px;">
    <h5 *ngIf="evidencePopupData.texts && evidencePopupData.texts.length > 0"
      style="color: #495057; font-weight: 600; margin-bottom: 10px;">Evidence Text</h5>
    <div class="evidence-text-container" *ngIf="evidencePopupData.texts && evidencePopupData.texts.length > 0"
      style="background-color: #f8f9fa; padding: 15px; border-radius: 5px; margin-bottom: 25px;">
      <div *ngFor="let txt of evidencePopupData.texts; let i = index" style="margin-bottom: 10px;">
        <p style="margin-bottom: 0; font-family: monospace; font-size: 13px; color: #333; line-height: 1.5;">
          {{i + 1}}) {{txt.text}}</p>
      </div>
    </div>

    <h5 *ngIf="evidencePopupData.screenshots && evidencePopupData.screenshots.length > 0"
      style="color: #495057; font-weight: 600; margin-bottom: 15px; border-bottom: 1px solid #eaeaea; padding-bottom: 5px;">
      Screenshots ({{evidencePopupData.screenshots.length}})</h5>
    <div *ngIf="evidenceScreenshotsLoading" style="text-align: center; padding: 20px;">
      <i class="fa fa-spinner fa-spin" style="font-size: 24px; color: #007bff;"></i>
      <p style="margin-top: 10px; color: #666; font-size: 13px;">Loading screenshots...</p>
    </div>

    <div class="evidence-screenshots-container" style="display: flex; flex-wrap: wrap; gap: 20px;"
      *ngIf="!evidenceScreenshotsLoading && evidencePopupData.screenshots && evidencePopupData.screenshots.length > 0">
      <div *ngFor="let screenshot of evidenceScreenshotObjects; let i = index" class="screenshot-card"
        style="border: 1px solid #dee2e6; border-radius: 5px; padding: 15px; text-align: center; width: 220px; background: white; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
          <p style="margin: 0; font-weight: bold; color: #666;">{{i + 1}}</p>
        </div>
        <img [src]="'data:image/png;base64,' + screenshot.image_base64" alt="Screenshot {{i + 1}}"
          style="width: 100%; height: auto; border: 1px solid #f1f1f1; margin-bottom: 15px; border-radius: 3px; cursor: pointer;"
          (click)="openBase64ImageInNewTab('data:image/png;base64,' + screenshot.image_base64)"
          title="Click to open full image" />
        <a href="javascript:void(0)"
          (click)="openBase64ImageInNewTab('data:image/png;base64,' + screenshot.image_base64)"
          style="color: #007bff; text-decoration: none; font-size: 13px; font-weight: 500;">Open Full Image ↗</a>
      </div>
    </div>

    <div
      *ngIf="(!evidencePopupData.texts || evidencePopupData.texts.length === 0) && (!evidencePopupData.screenshots || evidencePopupData.screenshots.length === 0)"
      style="text-align: center; padding: 20px; color: #666;">
      <p style="margin: 0; font-size: 14px;">No evidence available.</p>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Close" icon="pi pi-times" (click)="closeEvidencePopup()" class="p-button-text"
      style="color: #6c757d;"></button>
  </ng-template>
</p-dialog>